import React from "react";
import EconomicalTariffDTO from "features/economicalTariff/dtos/EconomicalTariffDTO";
import PriceFormatter from "features/shared/components/formatters/PriceFormatter";
import DateFormatter from "features/shared/components/formatters/DateFormatter";
import InfoItemMobile from "features/shared/components/infoItem/InfoItemMobile";
import { useTranslation } from "react-i18next";

type Props = {
  tariff: EconomicalTariffDTO;
};

const EconomicalTariffItem = ({ tariff }: Props) => {
  // translations
  const t = useTranslation("economicalTariff\\economicalTariff").t;

  return (
    <div className="row no-gutters">
      <div className="col-lg-3">
        <InfoItemMobile
          title={t("economicalTariffItem.placeOfDelivery")}
          value={tariff.placeOfDelivery!}
          hideTitleOn="lg"
        />
      </div>
      <div className="col-lg-3 text-lg-center">
        <InfoItemMobile
          title={t("economicalTariffItem.distributionRate")}
          value={tariff.distributionRate!}
          hideTitleOn="lg"
        />
      </div>
      <div className="col-lg-3 text-lg-center">
        <InfoItemMobile
          title={t("economicalTariffItem.paymentDate")}
          value={<DateFormatter date={tariff.paymentDate!} />}
          hideTitleOn="lg"
        />
      </div>
      <div className="col-lg-3 text-lg-right">
        <InfoItemMobile
          title={t("economicalTariffItem.amount")}
          value={<PriceFormatter amount={tariff.amount!} currency="CZK" />}
          hideTitleOn="lg"
        />
      </div>
    </div>
  );
};

export default EconomicalTariffItem;
